import React from 'react';
import { Link } from 'react-router-dom';

const newsItems = [
  { id: 1, title: 'Kabinet presenteert nieuwe begroting', excerpt: 'Het kabinet has today de begroting voor 2026 gepresenteerd met forse investeringen in zorg en infrastructuur.', category: 'Binnenland', time: '2 uur geleden' },
  { id: 2, title: 'Verkiezingen in zicht: peilingen tonen verschuiving', excerpt: 'Nieuwe peilingen tonen een verschuiving naar kleinere partijen.', category: 'Verkiezingen', time: '4 uur geleden' },
  { id: 3, title: 'Tweede Kamer debatteert over klimaatwet', excerpt: 'De Tweede Kamer bespreekt vandaag de aangescherpte klimaatdoelstellingen.', category: 'Klimaat', time: '6 uur geleden' },
  { id: 4, title: 'Minister van Onderwijs kondigt hervormingen an', excerpt: 'Grote veranderingen aangekondigd in het onderwijssysteem.', category: 'Onderwijs', time: '8 uur geleden' },
  { id: 5, title: 'Europese top bespreekt migratiebeleid', excerpt: 'Leiders van EU-landen komen bijeen over nieuw migratiebeleid.', category: 'Europa', time: '12 uur geleden' },
  { id: 6, title: 'Kamer meerderheid voor nieuwe zorgwet', excerpt: 'De Tweede Kamer heeft ingestemd met de nieuwe zorgwet.', category: 'Zorg', time: '1 dag geleden' },
];

export default function NieuwsPage() {
  return (
    <div className="container mx-auto px-4 py-16">
      <h1 className="text-5xl font-bold mb-12 text-center text-gray-800">Laatste Nieuws</h1>
      <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
        {newsItems.map(item => (
          <article key={item.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition flex">
            <img src={`https://picsum.photos/seed/news${item.id}/200/200`} alt={item.title} className="w-48 h-48 object-cover" />
            <div className="p-6 flex-1">
              <div className="flex justify-between items-center mb-2">
                <span className="text-sm text-red-600 font-semibold">{item.category}</span>
                <span className="text-sm text-gray-500">{item.time}</span>
              </div>
              <h3 className="text-lg font-bold mb-2">{item.title}</h3>
              <p className="text-gray-600 text-sm mb-3">{item.excerpt}</p>
              <Link to={`/nieuws/${item.id}`} className="text-red-600 font-semibold text-sm hover:text-red-800">Lees verder →</Link>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
